import { AxiosResponse } from 'axios'
import Request from '../config/services/Request'

import type { KingCountyEmployeeInviteSignUpPayload } from 'redux/KingCounty/kingCountyTypes'

export type BikeWaitlistStatusValue =
  | 'WAITING'
  | 'SELECTED'
  | 'WITHDRAWN'
  | null

export type BikeWaitlistStatus = {
  status: BikeWaitlistStatusValue
}

const kingCountyEmployeeInviteSignUp = (
  payload: KingCountyEmployeeInviteSignUpPayload
): Promise<AxiosResponse> => {
  return Request.post('/auth/register/wi/', payload)
}

const selectBikeForCheckout = (bikeId: string): Promise<AxiosResponse> => {
  return Request.post('/king_county/selected-bike/', { bikeId })
}

const getBikeWaitlist = (): Promise<AxiosResponse<BikeWaitlistStatus>> => {
  return Request.get('/king_county/bike-waitlist/')
}

const joinBikeWaitlist = (): Promise<AxiosResponse<BikeWaitlistStatus>> => {
  return Request.post('/king_county/bike-waitlist/', {})
}

const withdrawFromBikeWaitlist = (): Promise<
  AxiosResponse<BikeWaitlistStatus>
> => {
  return Request.del('/king_county/bike-waitlist/')
}

export default {
  kingCountyEmployeeInviteSignUp,
  selectBikeForCheckout,
  getBikeWaitlist,
  joinBikeWaitlist,
  withdrawFromBikeWaitlist,
}
